import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/adesao'

class AdesaoBpmApiClient {
	async buscarExtensionsTask({ taskDefinitionKey, isAdesaoExterna }) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/bpm/get-extensions/${taskDefinitionKey}`,
			filters: { isAdesaoExterna },
		}).build()

		return await axios.get(url)
	}
}

export default new AdesaoBpmApiClient()
